// src/hooks/useMediaQuery.ts
//
// Minimal viewport-branch hook. Two Home sections need genuinely different
// interaction per viewport (not just different CSS), and rendering both
// versions and hiding one with CSS duplicates the content for screen readers.
// So the branch happens in JS and only one version is in the DOM at a time.
import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(mql.matches);
    mql.addEventListener('change', onChange);

    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
